module.exports = __webpack_public_path__ + "static/media/sathyabama.a03c0c8d.jpeg";